import { BreadcrumbLink } from '../types/navigation';

export type BreadcrumbItem = BreadcrumbLink | { isEllipsis: true };

/**
 * Truncates breadcrumb links if they exceed the maximum number of levels.
 *
 * Logic defined in specs/010-dashboard-layout-navigation/research.md:
 * - If links.length <= 4, show all.
 * - If links.length > 4, show: [Root, ..., Last-2, Last-1, Current].
 *
 * @param links The full array of breadcrumb links
 * @param maxLevels The maximum number of levels before truncation (default 4)
 * @returns An array of breadcrumb items including an ellipsis if truncated
 */
export function truncateBreadcrumbs(links: BreadcrumbLink[], maxLevels = 4): BreadcrumbItem[] {
  if (links.length <= maxLevels) {
    return links;
  }

  // links.length is definitely > 0 here because maxLevels >= 1 (usually 4)
  const root = links[0] as BreadcrumbItem;
  const lastThree = links.slice(-3);

  return [root, { isEllipsis: true }, ...lastThree];
}
